import { styled } from "@mui/material/styles";

const ExplanationParagraph = styled("div")({
    margin: "0.5rem 0"
})
export default ExplanationParagraph;